import { render, staticRenderFns } from "./DisMoney.vue?vue&type=template&id=16220bb4"
import script from "./DisMoney.vue?vue&type=script&lang=js"
export * from "./DisMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports